// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RefractionEyeResponse } from './refraction-eye-response';

/** See com.rev360.pms.api.controller.patient.opticalsummary.OpticalSummaryLatestFindingsRefractionResponse */
/* istanbul ignore next */
@GandalfModel
export class OpticalSummaryLatestFindingsRefractionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	addVisualAcuity!: string | null;

	@GandalfProperty({ designType: String })
	addVisualAcuityModifier!: string | null;

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfProperty({ designType: Date })
	lastUpdated!: Date | null;

	@GandalfProperty({ designType: RefractionEyeResponse })
	od!: RefractionEyeResponse | null;

	@GandalfProperty({ designType: String })
	odVisualAcuity!: string | null;

	@GandalfProperty({ designType: String })
	odVisualAcuityModifier!: string | null;

	@GandalfProperty({ designType: RefractionEyeResponse })
	os!: RefractionEyeResponse | null;

	@GandalfProperty({ designType: String })
	osVisualAcuity!: string | null;

	@GandalfProperty({ designType: String })
	osVisualAcuityModifier!: string | null;

	@GandalfProperty({ designType: String })
	ouVisualAcuity!: string | null;

	@GandalfProperty({ designType: String })
	ouVisualAcuityModifier!: string | null;

	@GandalfProperty({ designType: String })
	refractionName!: string | null;

}
